import { type Country } from '@module/mdrt-org/shared/utils/types/countries';
import { type SelectOption } from '@shared/utils/types/select-option';

export const getDefaultPhoneIsoCodeOption = ({
  countriesData,
  countryId,
  phoneIsoCodeOptions,
}: {
  countriesData: Country[];
  countryId: Nullable<number>;
  phoneIsoCodeOptions: Array<SelectOption<string>>;
}) => {
  const businessAddressCountry = countriesData?.find((country) => country.countryId === countryId);

  return (
    phoneIsoCodeOptions.find(
      (option) => option && option.value === businessAddressCountry?.telephoneCode
    ) || null
  );
};
